import { render, staticRenderFns } from "./StepHeaderComponent.vue?vue&type=template&id=25b86134"
import script from "./StepHeaderComponent.vue?vue&type=script&lang=ts"
export * from "./StepHeaderComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports